import { createContext } from "react"

const ThemeCtx = createContext<{ theme: "dark" | "light" }>({
  theme: "dark"
})

export default ThemeCtx
